module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_9005.e3518b91.png";